import classNames from 'classnames';
import NavGroupItem from '../NavGroupItem';

const NavGroup = ({ children, submenu = false }: any) => {
  const navGroupClass = classNames('nav nav-pills flex-column mb-auto', {
    'ms-3': submenu
  });

  return <ul className={navGroupClass}>{children}</ul>;
};

export default Object.assign(NavGroup, {
  Item: NavGroupItem
});
